import { render, staticRenderFns } from "./NotPermission.vue?vue&type=template&id=cae9a120&scoped=true"
import script from "./NotPermission.vue?vue&type=script&lang=js"
export * from "./NotPermission.vue?vue&type=script&lang=js"
import style0 from "./NotPermission.vue?vue&type=style&index=0&id=cae9a120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae9a120",
  null
  
)

export default component.exports